import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import api from "../../util/api";
import swal from "sweetalert";

// import "bootstrap/dist/css/bootstrap.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';

import Footer from "../common/Footer";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";

const Wallets = () => {
    const navigate = useNavigate();

    const [wallets, setWallets] = useState([]);

    useEffect(() => {
        getWallets();
    }, []);


  async function getWallets() {
    const token = localStorage.getItem("token");
    try {
      const res = await api.get("/admin/all-wallets", {
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      });
    if (res.data.success) {
        setWallets(res.data.wallets);
      }
    } catch (err) {
      swal("Failed!", "error", {
        button: false,
        timer: 1500
      });
    }
  }

  const columns = [
    {
      dataField: "sn",
      text: "ID",
    //   filter: textFilter(),
      sort: true
    },
    {
      dataField: "firstname",
      text: "Customer Name",
      formatter: (cellContent, row) => {
        return (<span>{row.first_name} {row.last_name}</span>);
      },
      sort: true
    },
    {
      dataField: "email",
      text: "Email",
      sort: true
    },
    {
      dataField: "id",
      text: "Reference ID"
    },
    {
      dataField: "id",
      text: "Action",
      formatter: (cellContent, row) => (
        <a onClick={
          ()=>navigate('/wallet', {
              state: {
                  wallet: row,
              }
            })
      } href="" className="text-primary">View Wallet</a>
      )
    }
  ];


  return (
<div>
        <Header/>
        <Sidebar/>
        <main id="main" className="main">
          <div className="pagetitle">
            <h1>Wallets</h1>
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><a href="/">Home</a></li>
                <li className="breadcrumb-item active">Wallets</li>
              </ol>
            </nav>
          </div>{/* End Page Title */}
          <section className="section dashboard">
            <div className="row">
              {/* Left side columns */}
              <div className="col-lg-12">
                <div className="row">
                  {/* Users Card */}
                  <div className="col-xxl-6 col-md-6">
                    <div className="card info-card sales-card">
                      <div className="filter">
                        <a className="icon" href="#" data-bs-toggle="dropdown"><i className="bi bi-three-dots" /></a>
                        <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                          <li className="dropdown-header text-start">
                            <h6>Filter</h6>
                          </li>
                          <li><a className="dropdown-item" href="#">Today</a></li>
                          <li><a className="dropdown-item" href="#">This Month</a></li>
                          <li><a className="dropdown-item" href="#">This Year</a></li>
                        </ul>
                      </div>
                      <div className="card-body">
                        <h5 className="card-title">All Wallets</h5>
                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-wallet2" />
                          </div>
                          <div className="ps-3">
                            <h6>{wallets.length}</h6>
                             <span className="text-muted small pt-2 ps-1">Registered Wallets</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>{/* End Users Card */}
                  {/* Approved Card */}
                  <div className="col-xxl-6 col-md-6">
                    <div className="card info-card revenue-card">
                      <div className="filter">
                        <a className="icon" href="#" data-bs-toggle="dropdown"><i className="bi bi-three-dots" /></a>
                        <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                          <li className="dropdown-header text-start">
                            <h6>Filter</h6>
                          </li>
                          <li><a className="dropdown-item" href="#">Today</a></li>
                          <li><a className="dropdown-item" href="#">This Month</a></li>
                          <li><a className="dropdown-item" href="#">This Year</a></li>
                        </ul>
                      </div>
                      <div className="card-body">
                        <h5 className="card-title">Wallet Balance</h5>
                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-wallet2" />
                          </div>
                          <div className="ps-3">
                            <h6>{0}</h6>
                            <span className="text-muted small pt-2 ps-1">Available Wallets Fund</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>{/* End Approved Card */}
                  

                  {/* All Wallets */}
                  <div className="col-12">
                    <div className="card recent-sales overflow-auto">
                      <div className="filter">
                        <a className="icon" href="#" data-bs-toggle="dropdown"><i className="bi bi-three-dots" /></a>
                        <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                          <li className="dropdown-header text-start">
                            <h6>Filter</h6>
                          </li>
                          <li><a className="dropdown-item" href="#">Today</a></li>
                          <li><a className="dropdown-item" href="#">This Month</a></li>
                          <li><a className="dropdown-item" href="#">This Year</a></li>
                        </ul>
                      </div>
                      <div className="card-body">
                        <h5 className="card-title">All Wallets <span>| Today</span></h5>
                        <BootstrapTable
                            bootstrap4
                            keyField="id"
                            data={wallets}
                            columns={columns}
                            bordered={ false }
                            pagination={paginationFactory({ sizePerPage: 20 })}
                        />
                      </div>
                    </div>
                  </div>{/* End All Wallets */}

                </div>
              </div>{/* End Left side columns */}
            </div>
          </section>
        </main>{/* End #main */}
       <Footer/>
        <a href="#" className="back-to-top d-flex align-items-center justify-content-center"><i className="bi bi-arrow-up-short" /></a>
      </div>
  );
};
export default Wallets;